export default class TimeoutError extends Error {
  constructor(...params) {
    super(...params)
    this.name = 'TimeoutError'
  }
}
